<template>
<div class="row">
  <div class="Absolute-Center is-Responsive">
    <div style="font-size: 2em;">
      <p style="color: black;">Batam Teknik Medan</p>
    </div>
    <!-- <div class="col-sm-12">
      <div class="form-group col-md-12">
        <p>Congratulations !! You have just verify your email address.</p>
        <p>Use below button to Login.</p>
      </div>
      <button class="btn btn-primary btn-block" @click="login">Bring me back to Login!</button> 
    </div>   -->
    <div v-if="isHidden" class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    <div v-if="isHidden">Updating your data... Please Wait</div>
    <div v-if="!isHidden" class="col-sm-12">
      <div class="form-group col-md-12">
        <input type="email" disabled class="form-control" id="app-email-address" aria-describedby="emailHelp" placeholder="Email" v-model="mm.email">
      </div>
      <div class="form-group col-md-12">
        <input type="password" @keyup.enter="login" class="form-control" id="exampleInputPassword1" placeholder="Password" v-model="mm.password">
      </div>
      <button class="btn btn-primary btn-block" v-on:click="isHidden = true" @click="save">Reset Password !</button> 
    </div>  
  </div>      
</div>
</template>

<script>
import api from '../services/api'
import { memberManagement } from '../models/memberManagement'
// import AppLookupField from '../../components/AppLookupField.vue'
// import AppDatatable from '../../components/AppDatatable.vue'
// import AppDatePicker from '../../components/AppDatePicker.vue'

export default {
//   components: {
//     AppLookupField, AppDatatable, AppDatePicker
//   },
  data() {
    return {
      mm: {
        ...memberManagement
      },
      isHidden: false
    }
  },
  async created() {
    const mmApi = api('reset-password')
    this.mm = await mmApi.getWithParams(this.$route.query.id)
  },
  methods: {
    async save() {
        console.log(this.mm)
        const signUpApi = api('reset-password')
        await signUpApi.update(this.mm)
        this.$router.push({ name: 'login' })
    }
  }
}
</script>